import { cancel } from 'helpers/dom-helper';
import { brandedId } from 'helpers/random-id';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['btn', 'popover'];

  connect() {
    if (!this.popoverTarget.id) {
      this.popoverTarget.id = brandedId();
    }

    this.btnTarget.setAttribute('aria-controls', this.popoverTarget.id);
    this.btnTarget.setAttribute('aria-expanded', (!this.popoverTarget.hidden).toString());
  }

  popoverTargetConnected(target) {
    this.element.toggleAttribute('open', !target.hidden);
    if (!target.id) target.id = brandedId();
    target.setAttribute('tabindex', '-1');
  }

  popoverTargetDisconnected() {
    this.close();
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  closeOnOutsideInteraction(event) {
    if (!this.isOpen) return;
    if (this.element.contains(event.target)) return;

    this.close();
  }

  closeOnOutsideInteractionModalAware(event) {
    if (event.target.closest('[role="dialog"]') || event.target.closest('.modal')) return;
    this.closeOnOutsideInteraction(event);
  }

  closeOnEscape(event) {
    if (!this.isOpen) return;

    if (event.key === 'Escape' || event.key === 'Esc') {
      cancel(event);
      this.close(true);
    }
  }

  close(focus = false) {
    this.dispatchEvent('hide');
    this.element.removeAttribute('open');
    this.popoverTarget.hidden = true;
    if (this.hasBtnTarget) {
      if (focus && typeof focus === 'boolean') this.btnTarget.focus();
      this.btnTarget.setAttribute('aria-expanded', 'false');
    }

    this.dispatchEvent('hidden');
  }

  open() {
    this.dispatchEvent('show');
    this.element.setAttribute('open', '');
    this.popoverTarget.hidden = false;
    this.btnTarget.setAttribute('aria-expanded', 'true');
    this.dispatchEvent('shown');
  }

  dispatchEvent(name) {
    this.dispatch(name, { target: this.popoverTarget, bubbles: true });
  }

  // Private

  get isOpen() {
    return this.element.hasAttribute('open');
  }
}
